module.exports = __webpack_public_path__ + "img/main-banner.45114b08.svg";